module.exports = __webpack_public_path__ + "img/fi-organic-breakfast-400x263.76ec6f72.jpg";